import { IState } from 'shared/store';

export const selectReportUserEmail = (state: IState) => {
  return state.bestPlaceAnalytics.userEmail;
};
